'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var useReturns = require('../../hooks/useReturns.js');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReviewSummaryPage = () => {
  const {
    orderData,
    submittedReturn,
    setSubmittedReturn
  } = useReturns["default"]();
  const navigate = reactRouterDom.useNavigate();
  const resetApp = () => {
    var _orderData$items;
    if (submittedReturn || !(orderData !== null && orderData !== void 0 && orderData.items) || !((orderData === null || orderData === void 0 ? void 0 : (_orderData$items = orderData.items) === null || _orderData$items === void 0 ? void 0 : _orderData$items.length) > 0)) {
      navigate('/');
    }
  };
  const resetAppRef = React.useRef(resetApp);
  React.useEffect(() => {
    resetAppRef.current();
  }, []);
  const onSubmit = _ref => {
    let {
      value
    } = _ref;
    if (value !== null && value !== void 0 && value.submittedReturn) {
      setSubmittedReturn === null || setSubmittedReturn === void 0 ? void 0 : setSubmittedReturn(value === null || value === void 0 ? void 0 : value.submittedReturn);
      navigate('/confirmation');
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    review: {
      onSubmit,
      onBack: () => {
        navigate('/pudo');
      }
    }
  });
};

exports["default"] = ReviewSummaryPage;
